import React, { Component } from "react";
import '../App.css'
import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';
 class TeamInfo extends Component {
        render(){
            return(
                <div>
                   <label>Team Name</label> <input type="text"></input><br></br>
                   <label>Team Logo</label> <input type="file"></input><br></br>    
                   <label>Team Hex 1</label> <ColorPickerComponent ref={(scope) => this.colorPicker = scope}
                id='colorpicker'
                type='text'
                created={this.onCreated}
                className='e-input' /><input type="text"></input><br></br>    
                   <label>Team Hex 2</label><ColorPickerComponent ref={(scope) => this.colorPicker = scope}
                id='colorpicker'
                type='text'
                created={this.onCreated}
                className='e-input' /> <input type="text"></input><br></br>       
                    <button type="submit">Submit</button>
                    <button type="cancel">Cancel</button>
                </div>
            )

            
        }
}
export default TeamInfo